"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledShapesSkeleton = exports.StyledSvg = exports.StyledShapesContainer = exports.StyledSelectContainer = exports.StyledContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  height: 100%;
  width: 100%;
  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
  `}
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
`;
exports.StyledSelectContainer = styled_components_1.default.div `
  width: 100%;
  width: 100%;
  display: flex;
`;
exports.StyledShapesContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  overflow-y: auto;
  ${({ theme }) => theme.Scrollbar.Panel}
`;
exports.StyledSvg = styled_components_1.default.svg `
  cursor: pointer;
`;
exports.StyledShapesSkeleton = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
//# sourceMappingURL=Shapes.styles.js.map